const adminDashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "Site Setup",
    // path: "",
    icon: "fas fa-sign-out-alt",
  },
  {
    path: "/units",
    name: "Units And Permits",
    icon: "icon-manage_residents",
  },
  {
    path: "/view-occupancy",
    name: "OCCUPANCY",
    icon: "icon-occupancy",
  },
  {
    path: "/visitor-permit",
    name: "Add Visitor",
    icon: "icon-add-visitor",
  },
  {
    path: "/current-visitor-permit",
    name: "Current Visitors",
    icon: "icon-current-visitor",
  },
  {
    path: "/current-permits",
    name: "View All Permits",
    icon: "icon-view-permits",
  },
  {
    path: "/lpr-report",
    name: "LPR Report",
    icon: "icon-lpr-report",
  },
  {
    path: "/unit-occupancy",
    name: "Parking Log",
    icon: "fas fa-clipboard-check",
  },
  {
    path: "/photo-verify",
    name: "Photo Verify",
    icon: "icon-photo-verify",
  },
  {
    path: "/current-occupancy",
    name: "Plate Audit",
    icon: "icon-plate-audit",
  },
  {
    path: "/report",
    name: "Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-enforcement-citation-issued",
    name: "Citation Issued Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-enforcement-citation-paid-summary",
    name: "Citation Paid Report",
    icon: "fas fa-file",
  },
  {
    path: "/audit-report",
    name: "Photo Verify Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-enforcement-citation-analysis",
    name: "Citation Analysis Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-citation",
    name: "Citation Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-revenue",
    name: "Revenue Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-health",
    name: "Health Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-dispenser",
    name: "Ticket Dispenser Report",
    icon: "fas fa-file",
  },
  {
    path: "/report-vend-control",
    name: "Vend Control",
    icon: "fas fa-file",
  },
  {
    path: "/report-validation",
    name: "Validation report",
    icon: "fas fa-file",
  },
  {
    path: "/report-rate-tracking",
    name: "Rate Tracking report",
    icon: "fas fa-file",
  },
  {
    path: "/report-transactions",
    name: "Transactions report",
    icon: "fas fa-file",
  },
  {
    path: "/report-vend-control",
    name: "Vend Control report",
    icon: "fas fa-file",
  },
  {
    path: "/refund",
    name: "Refund Report",
    icon: "fas fa-file",
  },

  // {
  //   path: "/enforcement-report",
  //   name: "Enforcement Report",
  //   icon: "fas fa-file",
  // },
  // {
  //   path: "/audit-report",
  //   name: "Audit Report",
  //   icon: "icon-lpr-reports",
  // },
  {
    path: "/live-feed",
    name: "Live Feed",
    icon: "icon-live-Feed",
  },
  {
    path: "/smart-gate",
    name: "Smart Gate",
    icon: "icon-smart-gate",
  },
  {
    path: "/citation-list",
    name: "CITATIONS",
    icon: "icon-ticket-list",
  },
  {
    path: "/lot-sharing",
    name: "LOT SHARING",
    icon: "icon-lot-sharing",
  },
  {
    path: "/add-quick-permit",
    name: "QUICK PERMITS",
    icon: "icon-quick-permit",
  },
  {
    path: "/self-register",
    name: "SELF REGISTER",
    icon: "icon-self-register",
  },
  {
    path: "/contact",
    name: "Contact Support",
    icon: "fas fa-phone-square-alt",
  },
  {
    path: "/user-profile",
    name: "My Account",
    icon: "fas fa-user-circle",
  },
  {
    path: "/activity-log-report",
    name: "ACTIVITY LOGS REPORT",
    icon: "fas fa-user-circle",
  },

  {
    name: "Logout",
    icon: "fas fa-sign-out-alt",
  },
];

export default adminDashboardRoutes;
